import {
  getAccommodationSubcategoryPriority,
  getAllAccommodationSubcategoryKeywords,
  getLocaleAwareSubcategoryKeywords,
} from './languages';
import {
  type SubcategoryConfig,
  type SubcategoryResult,
  detectSubcategory,
} from './subcategoryDetection';
import { EXPENSE_TAXONOMY } from './taxonomy';

export const ACCOMMODATION_KEYWORDS = getAllAccommodationSubcategoryKeywords();

/** Derived from the canonical `EXPENSE_TAXONOMY`. See taxonomy.ts. */
export const VALID_ACCOMMODATION_SUBCATEGORIES =
  EXPENSE_TAXONOMY.accommodation as readonly string[] as string[];

export const ACCOMMODATION_CONFIG: SubcategoryConfig = {
  keywords: ACCOMMODATION_KEYWORDS,
  validSubcategories: VALID_ACCOMMODATION_SUBCATEGORIES,
  contextKeywords: {},
  minConfidenceThreshold: 0.3,
  subcategoryPriority: getAccommodationSubcategoryPriority(),
};

export function detectAccommodationSubcategory(description: string): string {
  return detectSubcategory(description, ACCOMMODATION_CONFIG).subcategory;
}

export function detectAccommodationSubcategoryWithConfidence(
  description: string
): SubcategoryResult {
  return detectSubcategory(description, ACCOMMODATION_CONFIG);
}

/**
 * Locale-aware accommodation subcategory detector. Combines global
 * brand keywords (Marriott, Hilton, Ibis, Booking.com, Airbnb, VRBO,
 * Meliá, etc.) with the user's primary-language common-word vocabulary.
 * Returns `default@0` when locale doesn't resolve so cloud LLM can step in.
 */
export function detectAccommodationSubcategoryWithLocale(
  description: string,
  locale: string | undefined | null
): SubcategoryResult {
  const keywords = getLocaleAwareSubcategoryKeywords(
    b => b.accommodationSubcategories,
    k => k.accommodationSubcategories,
    locale
  );
  if (!keywords) {
    return { subcategory: 'default', confidence: 0, matchedKeywords: [] };
  }
  return detectSubcategory(description, {
    ...ACCOMMODATION_CONFIG,
    keywords,
  });
}
